<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <vue-title :title="pageTitle + ' | JUDO POS'"></vue-title>

    <v-alert
      :value="!wholeSaleHeader.customerName"
      color="warning"
      icon="priority_high"
      class="mb-4 py-2"
    >
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>Please Select Customer First</v-flex>
        <v-flex xs12 sm6 class="text-xs-left text-sm-right">
          <v-btn
            color="white"
            outline
            small
            @click="showCustomers()"
            class="mx-0"
          >
            <v-icon left>person</v-icon> Select Customer
          </v-btn>
        </v-flex>
      </v-layout>
    </v-alert>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap class="fill-height">
        <v-flex xs12 md6>
          <v-card>
            <v-flex class="px-3 mb-2">
              <v-layout row wrap>
                <v-flex>
                  <v-btn
                    icon
                    small
                    class="mx-0"
                    @click="goBack"
                    title="Go Back"
                  >
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex>
                  <v-radio-group
                    v-model="isWholesale"
                    row
                    @change="changeSellingPrice()"
                    :disabled="!!wholeSaleHeader.id"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                    hide-details
                    class="mt-1"
                  >
                    <v-radio :value="true" label="Wholesale"></v-radio>
                    <v-radio :value="false" label="Retail Sale"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="d-flex">
                  <v-checkbox
                    label="Discount"
                    v-model="isItemDiscount"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'DRAFT' ||
                      status == 'QUOTATION' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN'
                    "
                    hide-details
                    single-line
                    class="mt-1"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="isFOC"
                    label="FOC"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                    hide-details
                    class="mt-1"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-divider></v-divider>

            <!-- Bin / Barcode / product -->
            <v-flex class="px-3">
              <v-layout row>
                <!-- Bin list -->
                <v-flex xs12>
                  <v-select
                    prepend-icon="border_all"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER' ||
                      !wholeSaleHeader.customerName
                    "
                    :items="binList"
                    item-text="name"
                    item-value="id"
                    label="Bin"
                    v-model="wholeSaleHeader.binId"
                    :rules="rules.binRules"
                    hide-details
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <!-- Barcode input -->
                <v-flex xs6>
                  <v-text-field
                    name="scanBarcode"
                    label="Scan barcode....."
                    v-model="scanBarcode"
                    type="text"
                    v-on:keyup.enter="trigger(scanBarcode)"
                    autofocus
                    prepend-icon="filter_center_focus"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER' ||
                      !wholeSaleHeader.customerName ||
                      !wholeSaleHeader.binId
                    "
                  ></v-text-field>
                </v-flex>
                <!-- product code/name -->
                <v-flex xs6>
                  <v-autocomplete
                    name="enteredProductCode"
                    label="Product Code/Name"
                    v-model="enteredProductCode"
                    :items="productListByCodeOrName"
                    :filter="productSelectFilter"
                    v-on:keyup.enter="getProductByCode(enteredProductCode)"
                    autofocus
                    prepend-icon="assignment_returned"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER' ||
                      !wholeSaleHeader.customerName ||
                      !wholeSaleHeader.binId
                    "
                    item-text="code"
                    item-value="code"
                    :search-input.sync="codeSearch"
                    menu-props="auto"
                  >
                    <template v-slot:item="data">
                      <v-list-tile-content
                        @click="getProductByCode(data.item.code)"
                      >
                        {{ data.item.code + "/" + data.item.name }}
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-divider></v-divider>

            <div
              v-if="
                wholeSaleHeader.customerName && $vuetify.breakpoint.smAndDown
              "
              class="pa-1"
            >
              <v-btn
                color="primary"
                outline
                block
                @click="showCategoryProduct = !showCategoryProduct"
              >
                {{ showCategoryProduct ? "hide" : "show" }} Items
              </v-btn>
            </div>

            <category-product-list
              v-show="showCategoryProduct"
              @select="showProductUnitDialog($event)"
              :queryParams="productQueryParams"
              :customerName="wholeSaleHeader.customerName"
              :binId="wholeSaleHeader.binId"
              :orderNo="wholeSaleHeader.orderNo"
              :isFOC="isFOC"
            ></category-product-list>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <div class="top-sticky">
            <!-- top btns -->
            <v-card>
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs12 sm12 class="pa-0">
                    <v-flex class="pa-0 d-flex">
                      <v-btn
                        flat
                        :disabled="
                          wholeSaleHeader.id ||
                          roleName == 'ADMIN' ||
                          roleName == 'FINANCE_MANAGER' ||
                          !wholeSaleHeader.customerName
                            ? true
                            : false
                        "
                        @click.stop="showOrders()"
                        small
                      >
                        <v-icon left v-if="!wholeSaleHeader.ordNo">
                          vertical_align_bottom
                        </v-icon>
                        {{ computedCustomerOrder }}
                      </v-btn>

                      <v-divider
                        vertical
                        v-if="!$vuetify.breakpoint.xs"
                      ></v-divider>
                    </v-flex>

                    <v-flex v-if="$vuetify.breakpoint.xs">
                      <v-divider></v-divider>
                    </v-flex>
                  </v-flex>

                  <v-flex xs6 sm4 class="pa-0 d-flex" v-if="false">
                    <v-btn
                      flat
                      @click="showParkSales = true"
                      :disabled="
                        status == 'FINISHED' ||
                        status == 'CANCEL' ||
                        roleName == 'ADMIN' ||
                        roleName == 'FINANCE_MANAGER'
                      "
                      small
                    >
                      <v-icon left>unarchive</v-icon> Retrieve</v-btn
                    >
                    <v-divider vertical></v-divider>
                  </v-flex>

                  <v-flex xs6 sm4 class="pa-0 d-flex" v-if="false">
                    <v-btn
                      flat
                      @click="showNote = true"
                      :disabled="
                        wholeSaleHeader.wholeSaleDetails.length === 0 ||
                        status == 'FINISHED' ||
                        status == 'CANCEL' ||
                        roleName == 'ADMIN'
                      "
                      small
                    >
                      <v-icon left>archive</v-icon> Park</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card>

            <!-- Customer and sale meta -->
            <v-flex style="margin-top: 1px">
              <v-layout row wrap>
                <v-flex
                  xs6
                  sm4
                  class="pa-0"
                  :class="{ sm6: !wholeSaleHeader.id }"
                >
                  <v-tooltip bottom :disabled="!wholeSaleHeader.customerName">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        label="Customer Name"
                        :placeholder="`Customer ${
                          !wholeSaleHeader.customerName ? '(Required*)' : ''
                        }`"
                        v-model="wholeSaleHeader.customerName"
                        @click.stop="showCustomers()"
                        :rules="rules.customerIdRules"
                        :disabled="
                          wholeSaleHeader.id ||
                          roleName == 'ADMIN' ||
                          roleName == 'FINANCE_MANAGER'
                            ? true
                            : false
                        "
                        prepend-inner-icon="person"
                        hide-details
                        solo
                        :style="
                          $vuetify.breakpoint.smAndUp ? 'margin-right: 3px' : ''
                        "
                      >
                      </v-text-field>
                    </template>
                    <span>{{ wholeSaleHeader.customerName }}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex
                  xs6
                  sm4
                  class="pa-0"
                  :class="{ sm6: !wholeSaleHeader.id }"
                >
                  <v-menu
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    :disabled="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                  >
                    <v-text-field
                      label="IssueDate"
                      slot="activator"
                      type="text"
                      prepend-inner-icon="event"
                      v-model="computedIssueDate"
                      readonly
                      :rules="rules.issueDateRules"
                      solo
                      hide-details
                      :style="
                        $vuetify.breakpoint.smAndUp
                          ? 'margin-left: -2px; margin-right: -1px'
                          : ''
                      "
                    ></v-text-field>
                    <v-date-picker
                      v-model="issueDate"
                      :rules="rules.issueDateRules"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm4 class="pa-0" v-if="wholeSaleHeader.id">
                  <v-select
                    :items="statusList"
                    label="Status"
                    item-text="label"
                    item-value="value"
                    v-model="wholeSaleHeader.status"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                    solo
                    hide-details
                    :style="
                      $vuetify.breakpoint.smAndUp ? 'margin-left: 2px' : ''
                    "
                  >
                    <template v-slot:selection="{ item }">
                      Status:
                      <v-chip small>
                        {{ item.label }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>
          </div>
          <div class="cart-list-container">
            <!-- Sale Items cart -->
            <v-flex ma-1 my-2>
              <v-flex class="px-2">
                <v-layout row>
                  <v-flex
                    :class="{
                      'xs3 sm2 md2': isItemDiscount,
                      'xs3 sm2 md2': !isItemDiscount,
                    }"
                    class="text-xs-left"
                    >Item</v-flex
                  >
                  <v-flex
                    :class="{
                      'xs3 sm2 md2': isItemDiscount,
                      'xs3 sm3 md3': !isItemDiscount,
                    }"
                    class="text-xs-left"
                  >
                    Price
                  </v-flex>
                  <v-flex
                    :class="{
                      'xs3 sm2 md2': isItemDiscount,
                      'xs3 sm3 md3': !isItemDiscount,
                    }"
                    class="text-xs-left pl-4"
                  >
                    Qty
                  </v-flex>
                  <v-flex
                    v-if="isItemDiscount"
                    xs3
                    sm2
                    md2
                    class="text-xs-left"
                  >
                    Discount
                  </v-flex>
                  <v-flex
                    xs3
                    class="text-xs-right"
                    v-if="
                      ($vuetify.breakpoint.xs && !isItemDiscount) ||
                      !$vuetify.breakpoint.xs
                    "
                  >
                    Amount
                  </v-flex>
                  <v-flex
                    xs1
                    class="text-xs-right"
                    v-if="!$vuetify.breakpoint.xs"
                  ></v-flex>
                </v-layout>
              </v-flex>

              <template v-if="wholeSaleHeader.wholeSaleDetails.length == 0">
                <v-divider class="mt-1"></v-divider>

                <v-flex
                  class="text-xs-center mt-3"
                  v-if="wholeSaleHeader.wholeSaleDetails.length == 0"
                >
                  No items
                </v-flex>
              </template>

              <!-- cart items -->
              <v-card
                v-for="(item, index) in wholeSaleDetailList"
                :key="index"
                class="mt-1"
                :class="{
                  'cart-item': !item.isFOC,
                  'cart-item-foc': item.isFOC,
                }"
              >
                <v-flex class="pt-2 px-2">
                  <v-container fluid pa-1>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12 class="pb-0">
                        <span class="grey--text"> {{ item.barcode }} </span>
                        {{ item.productName }}
                        <!-- <span v-if="item.batchNo" class="primary--text">
                          ({{ item.batchNo }})
                        </span>
                        <span v-if="item.qcNo" class="green--text">
                          ({{ item.qcNo }})
                        </span> -->
                        <span v-if="item.isFOC">
                          -
                          <strong class="green--text"> <em>FOC</em></strong>
                        </span>
                      </v-flex>

                      <v-flex xs3 sm2 md2>
                        <div class="mt-1">{{ item.factorUnitName }}</div>
                      </v-flex>

                      <!-- unit price input -->
                      <v-flex
                        :class="{
                          'xs3 sm2 md2': isItemDiscount,
                          'xs3 sm3 md3': !isItemDiscount,
                        }"
                      >
                        <v-text-field
                          class="small-font mt-0 pt-0"
                          v-model="item.unitPrice"
                          type="number"
                          min="0"
                          :readonly="
                            status == 'FINISHED' ||
                            status == 'CANCEL' ||
                            roleName == 'ADMIN' ||
                            roleName == 'FINANCE_MANAGER' ||
                            item.isFOC
                          "
                          :rules="rules.unitPriceRules"
                          @input="onChangeDetail(item)"
                        ></v-text-field>
                      </v-flex>

                      <!-- qty input -->
                      <v-flex
                        class="d-flex"
                        :class="{
                          'xs3 sm2 md2': isItemDiscount,
                          'xs3 sm3 md3': !isItemDiscount,
                        }"
                      >
                        <div class="mt-1 mr-2">x</div>
                        <v-text-field
                          class="small-font mt-0 pt-0"
                          v-model="item.qty"
                          type="number"
                          min="0"
                          :rules="rules.qtyRules"
                          :readonly="
                            status == 'FINISHED' ||
                            status == 'CANCEL' ||
                            roleName == 'ADMIN' ||
                            roleName == 'FINANCE_MANAGER'
                          "
                          @input="onChangeDetail(item)"
                        ></v-text-field>
                      </v-flex>

                      <!-- discount -->
                      <v-flex v-if="isItemDiscount" xs3 sm2 md2>
                        <v-text-field
                          type="number"
                          class="small-font mt-0 pt-0"
                          v-model="item.discountPercent"
                          min="0"
                          :rules="rules.discountPercentRules"
                          suffix="%"
                          :readonly="
                            status == 'FINISHED' ||
                            status == 'CANCEL' ||
                            roleName == 'ADMIN' ||
                            roleName == 'FINANCE_MANAGER'
                          "
                          @change="onChangeDetail(item)"
                        ></v-text-field>
                      </v-flex>

                      <!-- amount -->
                      <v-flex
                        sm3
                        md3
                        :class="{
                          xs12: isItemDiscount,
                          xs3: !isItemDiscount,
                        }"
                      >
                        <div
                          class="mt-1 text-xs-right"
                          :class="{ 'grey--text': item.isFOC }"
                        >
                          <span v-if="$vuetify.breakpoint.xs && isItemDiscount">
                            Amount
                          </span>
                          <span v-if="isItemDiscount">
                            {{
                              (item.qty *
                                (item.unitPrice -
                                  item.unitPrice *
                                    (item.discountPercent / 100)))
                                | decFormat(6)
                            }}
                          </span>
                          <span v-else>
                            {{ (item.qty * item.unitPrice) | decFormat(6) }}
                          </span>
                          <span v-if="isShowCurrency">{{ currency }}</span>
                        </div>
                      </v-flex>

                      <v-flex
                        xs1
                        class="text-xs-right"
                        :class="{
                          'd-flex xs12': $vuetify.breakpoint.xs,
                        }"
                      >
                        <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>

                        <div>
                          <v-btn
                            icon
                            @click="onShowDetail(item)"
                            :disabled="status != 'FINISHED'"
                            class="ma-0 mb-1"
                            :small="!$vuetify.breakpoint.xs"
                          >
                            <v-icon color="grey">info</v-icon>
                          </v-btn>
                        </div>

                        <div>
                          <v-menu
                            left
                            :close-on-content-click="false"
                            :nudge-width="250"
                            :nudge-left="30"
                            transition="slide-x-reverse-transition"
                            origin="bottom left"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                icon
                                class="ma-0 mb-1"
                                :small="!$vuetify.breakpoint.xs"
                              >
                                <v-icon small>comment</v-icon>
                              </v-btn>
                            </template>

                            <v-card>
                              <v-flex class="pa-2 pt-3">
                                <v-textarea
                                  label="Remark"
                                  class="small-font"
                                  v-model="item.remark"
                                  :rules="rules.remarkRules"
                                  :readonly="
                                    status == 'FINISHED' ||
                                    status == 'CANCEL' ||
                                    roleName == 'ADMIN' ||
                                    roleName == 'FINANCE_MANAGER'
                                  "
                                  @change="onChangeDetail(item)"
                                  rows="4"
                                ></v-textarea>
                              </v-flex>
                            </v-card>
                          </v-menu>
                        </div>

                        <div>
                          <v-btn
                            icon
                            @click="removeItem(item)"
                            :disabled="
                              status == 'FINISHED' ||
                              status == 'CANCEL' ||
                              roleName == 'ADMIN' ||
                              roleName == 'FINANCE_MANAGER'
                            "
                            class="ma-0 mb-1"
                            :small="!$vuetify.breakpoint.xs"
                          >
                            <v-icon small>close</v-icon>
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-card>
            </v-flex>
          </div>
          <div class="bottom-sticky">
            <v-card>
              <v-flex>
                <v-flex class="px-2">
                  Shop Name:
                  {{ wholeSaleHeader.shopName }}
                </v-flex>

                <v-divider></v-divider>

                <v-flex class="px-2">
                  Sale Items:
                  <strong> {{ getSaleItems.length }} </strong>
                  <template v-if="getFOCItems.length">
                    | FOC Items:
                    <strong> {{ getFOCItems.length }} </strong>
                  </template>
                </v-flex>

                <v-divider></v-divider>

                <v-flex class="px-2 d-flex">
                  <span>
                    Total Amount + Tax({{ wholeSaleHeader.taxType }}
                    {{ wholeSaleHeader.taxPercentage }}%):
                  </span>
                  <v-spacer></v-spacer>
                  <span class="text-xs-right">
                    {{ wholeSaleHeader.totalAmount | decFormat(6) }}
                    + {{ wholeSaleHeader.taxAmount | decFormat(6) }}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </span>
                </v-flex>

                <v-divider></v-divider>

                <v-flex class="px-2 d-flex">
                  <h2>Net Amount:</h2>
                  <v-spacer></v-spacer>
                  <h2 class="text-xs-right">
                    {{ netAmount | decFormat(6) }}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </h2>
                </v-flex>

                <v-flex>
                  <v-flex xs12 text-xs-right>
                    <v-btn
                      color="success"
                      large
                      @click="showPaymentMethods()"
                      :disabled="
                        wholeSaleHeader.wholeSaleDetails.length === 0 || !valid
                      "
                    >
                      Make Payment
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Invoice print hidden area -->
    <!-- <invoice id="invoicePrint" :wholeSaleHeader-data="wholeSaleHeader"></invoice> -->
    <div
      id="invoicePrint"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 13px; margin: 0px; font-weight: bold">
          Whole Sale Invoice
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 11px; margin: 0px">
          {{ wholeSaleHeader.shopName }}
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 11px; margin: 0px">
          {{ wholeSaleHeader.address }}
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 11px; margin: 0px">
          Tel: {{ wholeSaleHeader.phoneNo }}
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 11px; margin: 0px">
          Invoice #: {{ wholeSaleHeader.issueNo }}
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 11px; margin: 0px" id="date"></p>
      </div>
      <div style="float: left; padding-left: 11px">
        <p style="font-size: 11px; margin: 0px" id="casher">
          Customer Name: {{ wholeSaleHeader.customerName }}
        </p>
      </div>
      <div style="float: left; padding-left: 11px">
        <p style="font-size: 11px; margin: 0px" id="casher">
          Customer Address: {{ wholeSaleHeader.customerAddress }}
        </p>
      </div>
      <div style="float: left; padding-left: 11px">
        <p style="font-size: 11px; margin: 0px" id="casher">
          Casher: {{ wholeSaleHeader.username }}
        </p>
      </div>
      <div style="clear: both"></div>
      <div style="height: 10px"></div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left"></th>
              <th style="text-align: center">Unit</th>
              <th style="text-align: center">Qty</th>
              <th style="text-align: right">Price</th>
              <th style="text-align: right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getSaleItems" :key="index">
              <td style="text-align: left">{{ item.productName }}</td>
              <td style="text-align: center">
                {{ item.factorUnitName }}
                <span v-if="wholeSaleHeader.isItemDiscount"
                  >({{ item.discountPercent }}%)</span
                >
              </td>
              <td style="text-align: center">
                {{ Number(item.qty) | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ item.unitPrice | decFormat(6) }}
              </td>
              <td style="text-align: right">
                <span v-if="wholeSaleHeader.isItemDiscount">{{
                  (item.qty *
                    (item.unitPrice -
                      item.unitPrice * (item.discountPercent / 100)))
                    | decFormat(6)
                }}</span>
                <span v-else>{{
                  (Number(item.qty) * Number(item.unitPrice)) | decFormat(6)
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="height: 10px"></div>
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <tr>
            <td
              colspan="3"
              style="text-align: right; font-weight: bold; font-size: 11px"
            >
              Total Amount
            </td>
            <td style="text-align: right; font-weight: bold; font-size: 11px">
              {{ wholeSaleHeader.totalAmount | decFormat(6) }}
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              style="text-align: right; font-weight: bold; font-size: 11px"
            >
              Tax ({{ wholeSaleHeader.taxType }})
            </td>
            <td style="text-align: right; font-weight: bold; font-size: 11px">
              {{ wholeSaleHeader.taxAmount | decFormat(6) }}
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              style="text-align: right; font-weight: bold; font-size: 11px"
            >
              Expense Amount
            </td>
            <td style="text-align: right; font-weight: bold; font-size: 11px">
              {{ this.wholeSaleHeader.deliveryFee | decFormat(6) }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align: right; font-weight: bold; font-size: 11px">
              Discount Amount
            </td>
            <td
              style="text-align: right; font-weight: bold; font-size: 11px"
              v-if="this.wholeSaleHeader.discountAmount > 0"
            >
              {{ this.wholeSaleHeader.discountAmount | decFormat(6) }}
            </td>
            <td
              style="text-align: right; font-weight: bold; font-size: 11px"
              v-else
            >
              0
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              style="text-align: right; font-weight: bold; font-size: 11px"
            >
              Net Amount
            </td>
            <td style="text-align: right; font-weight: bold; font-size: 11px">
              {{ netAmount | decFormat(6) }}
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              style="text-align: right; font-weight: bold; font-size: 11px"
            >
              Deposit Amount
            </td>
            <td
              style="text-align: right; font-weight: bold; font-size: 11px"
              v-if="this.depositAmount > 0"
            >
              {{ this.depositAmount | decFormat(6) }}
            </td>
            <td
              style="text-align: right; font-weight: bold; font-size: 11px"
              v-else
            >
              0
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              style="text-align: right; font-weight: bold; font-size: 11px"
            >
              Remaining Amount
            </td>
            <td style="text-align: right; font-weight: bold; font-size: 11px">
              {{ remainingAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
      <!-- FOC Items -->
      <div style="clear: both"></div>
      <div style="height: 10px"></div>
      <div
        style="padding-left: 5px; padding-right: 5px"
        v-if="getFOCItems.length > 0"
      >
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">FOC Items</th>
              <th style="text-align: center">Unit</th>
              <th style="text-align: center">Qty</th>
              <th style="text-align: right">Price</th>
              <th style="text-align: right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getFOCItems" :key="index">
              <td style="text-align: left">{{ item.productName }}</td>
              <td style="text-align: center">
                {{ item.factorUnitName }}
                <span v-if="wholeSaleHeader.isItemDiscount"
                  >({{ item.discountPercent }}%)</span
                >
              </td>
              <td style="text-align: center">
                {{ Number(item.qty) | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ item.unitPrice | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{
                  (item.qty *
                    (item.unitPrice -
                      item.unitPrice * (item.discountPercent / 100)))
                    | decFormat(6)
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="text-align: right" v-if="user.signature">
        <div style="display: inline-block">
          <img
            style="height: 100px; width: 100px; display: block"
            :src="user.signature"
          />
          <span style="display: block">------------------</span>
          <span style="display: block; text-align: center; font-size: 11px"
            >Signature</span
          >
        </div>
      </div>
      <div style="text-align: center">
        <p style="font-size: 11px">Money Pay Back Guarantee</p>
        <p style="font-size: 11px">Thank You Very Much</p>
      </div>
    </div>
    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Payment dialog-->
    <v-dialog
      v-model="showPaymentMethodDialog"
      persistent
      scrollable
      max-width="640px"
    >
      <v-card>
        <v-card-text style="height: 1000px" class="pa-4">
          <v-form ref="paymentModalForm" lazy-validation>
            <v-flex>
              <v-layout row wrap align-center>
                <v-flex xs6 md2>
                  <v-checkbox
                    v-model="isTaxOn"
                    @change="changeTaxOn"
                    :disabled="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                    hide-details
                    class="mt-0 pt-0"
                  >
                    <template v-slot:label>
                      <div>
                        <h5>Tax</h5>
                      </div>
                    </template>
                  </v-checkbox>
                </v-flex>
                <v-flex xs6 md4 v-show="false">
                  <v-checkbox
                    v-model="isAdvancedAmount"
                    @change="onAdvancedAmount"
                    :disabled="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                    hide-details
                    class="mt-0 pt-0"
                  >
                    <template v-slot:label>
                      <div>
                        <h5>Advanced Amount</h5>
                      </div>
                    </template>
                  </v-checkbox>
                </v-flex>
                <v-flex
                  xs12
                  md6
                  v-if="wholeSaleHeader.customerName"
                  class="py-2"
                  v-show="false"
                >
                  <v-layout row>
                    <v-flex xs6>
                      <h4>Total Advanced Amount:</h4>
                    </v-flex>
                    <v-flex xs6>
                      <h4>
                        {{ totaladvancedAmount | decFormat(6) }}
                      </h4>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-divider class="mt-3"></v-divider>

            <v-flex sm12>
              <v-layout>
                <v-flex sm2>
                  <div class="mt-4"><strong>Invoice No :</strong></div>
                </v-flex>
                <v-flex sm10>
                  <v-text-field
                    name="orderNo"
                    v-model="wholeSaleHeader.invoiceNo"
                    type="text"
                    :rules="rules.required('Invoice No')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm12>
              <v-layout>
                <v-flex sm2>
                  <div class="mt-4"><strong>Permit Date :</strong></div>
                </v-flex>
                <v-flex sm10>
                  <v-menu
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      type="text"
                      prepend-icon="event"
                      v-model="orderDate"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="orderDate"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm12>
              <v-layout>
                <v-flex sm2>
                  <div class="mt-4"><strong>Permit No :</strong></div>
                </v-flex>
                <v-flex sm10>
                  <v-text-field
                    name="orderNo"
                    v-model="wholeSaleHeader.orderNoText"
                    type="text"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm12>
              <v-layout>
                <v-flex sm2>
                  <div class="mt-4"><strong>Remark :</strong></div>
                </v-flex>
                <v-flex sm10>
                  <v-textarea
                    name="orderNo"
                    v-model="wholeSaleHeader.remark"
                    type="text"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-divider class="my-3"></v-divider>

            <v-flex>
              <v-flex class="mb-2">
                <strong>Total Amount:</strong>
                <h2>
                  <span
                    style="color: green"
                    :style="{
                      display: $vuetify.breakpoint.smAndDown
                        ? 'block'
                        : 'inline',
                    }"
                  >
                    {{ wholeSaleHeader.totalAmount | decFormat(6) }}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </span>
                </h2>
              </v-flex>

              <!-- customer margins -->
              <v-flex class="mb-4">
                <strong>Margin:</strong>
                <h2 v-for="(margin, index) in marginList" :key="index">
                  {{ margin.name }} :
                  <span style="color: red">
                    {{ margin.amount | decFormat(6) }}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </span>
                </h2>
              </v-flex>

              <!-- tax -->
              <v-flex v-if="isTaxOn" class="mb-2">
                <strong> Tax({{ wholeSaleHeader.taxType }}): </strong>
                <h2>
                  <span
                    style="color: red"
                    :style="{
                      display: $vuetify.breakpoint.smAndDown
                        ? 'block'
                        : 'inline',
                    }"
                  >
                    {{ wholeSaleHeader.taxAmount | decFormat(6) }}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </span>
                </h2>
              </v-flex>

              <!-- discount  -->
              <v-flex>
                <v-flex>
                  <v-layout row align-center>
                    <v-flex shrink>
                      <strong class="d-flex flex-shirnk"> Discount </strong>
                    </v-flex>

                    <v-flex grow>
                      <v-checkbox
                        class="mt-0 pt-0 ml-3"
                        v-model="isDiscountPercentage"
                        label="Percentage"
                        hide-details
                        @change="changeDiscountSwitch()"
                        :disabled="
                          status == 'FINISHED' ||
                          status == 'CANCEL' ||
                          roleName == 'ADMIN' ||
                          roleName == 'FINANCE_MANAGER'
                        "
                      >
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <h2>
                  <v-text-field
                    v-if="!isDiscountPercentage"
                    v-model="wholeSaleHeader.discountAmount"
                    label="Amount"
                    min="0"
                    :suffix="currency"
                    :rules="rules.discountAmountRules"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                  >
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </v-text-field>

                  <v-text-field
                    v-else
                    label="Percentage"
                    v-model="wholeSaleHeader.discountPercentage"
                    min="0"
                    :suffix="'%'"
                    :rules="rules.discountPercentRules"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                  >
                  </v-text-field>
                </h2>
              </v-flex>

              <!-- promotion -->
              <v-flex>
                <v-flex>
                  <v-layout row align-center>
                    <v-flex shrink>
                      <strong class="d-flex flex-shirnk"> Promotion </strong>
                    </v-flex>

                    <v-flex grow>
                      <v-checkbox
                        class="mt-0 pt-0 ml-3"
                        v-model="isPromotionPercentage"
                        label="Percentage"
                        hide-details
                        @change="changePromotionSwitch()"
                        :disabled="
                          status == 'FINISHED' ||
                          status == 'CANCEL' ||
                          roleName == 'ADMIN' ||
                          roleName == 'FINANCE_MANAGER'
                        "
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <h2>
                  <v-text-field
                    v-if="!isPromotionPercentage"
                    v-model="wholeSaleHeader.promotionAmount"
                    label="Amount"
                    min="0"
                    :suffix="currency"
                    :rules="rules.promotionAmountRules"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                  >
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </v-text-field>

                  <v-text-field
                    v-else
                    label="Percentage"
                    v-model="wholeSaleHeader.promotionPercentage"
                    min="0"
                    :suffix="'%'"
                    :rules="rules.promotionPercentRules"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                  >
                  </v-text-field>
                </h2>
              </v-flex>

              <!-- Expense -->
              <v-flex>
                <v-flex>
                  <strong> Expense </strong>
                  <h2>
                    <v-text-field
                      v-model="wholeSaleHeader.deliveryFee"
                      label="Amount"
                      min="0"
                      :rules="rules.discountAmountRules"
                      :readonly="
                        status == 'FINISHED' ||
                        status == 'CANCEL' ||
                        roleName == 'ADMIN' ||
                        roleName == 'FINANCE_MANAGER'
                      "
                    >
                      <span v-if="isShowCurrency">{{ currency }}</span>
                    </v-text-field>
                  </h2>
                </v-flex>
              </v-flex>

              <!-- net amount -->
              <v-flex class="my-2">
                <strong> Net Amount: </strong>
                <h1>
                  <span
                    style="color: green"
                    :style="{
                      display: $vuetify.breakpoint.smAndDown
                        ? 'block'
                        : 'inline',
                    }"
                  >
                    {{ netAmount | decFormat(6) }}
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </span>
                </h1>
              </v-flex>

              <!-- Deposit
              <v-flex>
                <strong> Deposit </strong>
                <h2>
                  <v-text-field
                    v-model="depositAmount"
                    label="Amount"
                    min="0"
                    outline
                    @input="changeDepositAmount"
                    @focus="$event.target.select()"
                    :prefix="currency"
                    :readonly="
                      status == 'FINISHED' ||
                      status == 'CANCEL' ||
                      roleName == 'ADMIN' ||
                      roleName == 'FINANCE_MANAGER'
                    "
                    :rules="rules.depositeAmountRules(netAmount)"
                  >
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </v-text-field>
                </h2>
              </v-flex>-->

              <v-flex>
                <v-textarea
                  :readonly="
                    status == 'FINISHED' ||
                    status == 'CANCEL' ||
                    roleName == 'ADMIN' ||
                    roleName == 'FINANCE_MANAGER'
                  "
                  solo
                  name="description"
                  label="Description"
                  v-model="wholeSaleHeader.description"
                ></v-textarea>
              </v-flex>

              <v-flex>
                <v-textarea
                  :readonly="
                    status == 'FINISHED' ||
                    status == 'CANCEL' ||
                    roleName == 'ADMIN' ||
                    roleName == 'FINANCE_MANAGER'
                  "
                  solo
                  name="delivery info"
                  label="Delivery Info"
                  v-model="wholeSaleHeader.deliveryInfo"
                  :rules="rules.deliveryInfoRules"
                ></v-textarea>
              </v-flex>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="error"
            flat
            @click="showPaymentMethodDialog = false"
            :icon="$vuetify.breakpoint.smAndDown"
          >
            <v-icon :left="!$vuetify.breakpoint.smAndDown">clear</v-icon>
            <span v-if="!$vuetify.breakpoint.smAndDown">Close</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="
              status == 'FINISHED' ||
              status == 'CANCEL' ||
              roleName == 'ADMIN' ||
              roleName == 'FINANCE_MANAGER'
            "
            color="success"
            large
            outline
            @click="confirmPayment"
          >
            Confrim Payment
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ProductUnit dialog -->
    <v-dialog v-model="openProductUnitDialog" persistent max-width="700">
      <v-card>
        <v-card-title>
          <h2>Choose Stock</h2>
        </v-card-title>
        <v-card-title>
          <h3>Product Code: {{ productCode }}</h3>
        </v-card-title>
        <v-card-title>
          <h3>Product Name: {{ productName }}</h3>
        </v-card-title>
        <!-- <v-divider></v-divider>
        <v-layout row wrap pa-2>
          <v-flex xs4 pa-1>
            <v-select
              :items="batchNoList"
              v-model="batchNo"
              label="Batch No"
              item-text="label"
              item-value="value"
              :loading="batchAndQcListLoading"
              @change="getAvailableStockQty(), changeExpDate()"
            ></v-select>
          </v-flex>
          <v-flex xs4 pa-1>
            <v-select
              :items="qcNoList"
              v-model="qcNo"
              label="QC No"
              item-text="label"
              item-value="value"
              :loading="batchAndQcListLoading"
              @change="getAvailableStockQty(), changeExpDate()"
            ></v-select>
          </v-flex>
          <v-flex xs4 pa-1>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              disabled
            >
              <v-text-field
                slot="activator"
                label="EXP Date"
                type="text"
                prepend-icon="event"
                v-model="expDate"
                readonly
              ></v-text-field>
              <v-date-picker v-model="expDate"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout> -->
        <v-layout row wrap pa-2>
          <v-flex
            v-for="(productUnit, index) in productUnitList"
            :key="index"
            xs12
            sm6
            md4
            lg3
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 4 : 0}`"
                class="mx-auto"
              >
                <v-card-title>
                  <p class="grey--text">{{ productUnit.barcode }}</p>
                  <p class="grey--text">{{ productUnit.product.name }}</p>
                  <p>
                    {{ getSellingPrice(productUnit) | decFormat(6) }}
                    MMK
                  </p>
                  <p>Unit: {{ productUnit.factorUnitName }}</p>
                  <p>
                    Available Qty:
                    <span v-if="availableQtyLoading">
                      <v-progress-circular
                        :size="20"
                        :width="1"
                        indeterminate
                      ></v-progress-circular>
                    </span>
                    <span v-else>{{ productUnit.qty | decFormat(6) }}</span>
                  </p>
                </v-card-title>
                <v-card-actions>
                  <v-btn
                    :disabled="productUnit.qty == 0 || availableQtyLoading"
                    :ref="`bc-${productUnit.barcode}`"
                    outline
                    color="orange"
                    @click="addToCart(productUnit)"
                    >Add To Card</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex v-if="!productUnitList.length">
            <h5 style="color: red">*There is no productUnit.</h5>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.native="closeProductUnitDialog"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <parked-sales-dialog
      :dialog.sync="showParkSales"
      @retrieved="onRetrievedParked"
    ></parked-sales-dialog>

    <park-sale-dialog
      :dialog.sync="showNote"
      :sale="wholeSaleHeader"
      @parked="onParked"
    ></park-sale-dialog>

    <sale-confirm-dialog
      :dialog.sync="confirmBox"
      :loading="isLoading"
      @confirm="onSaleConfirm"
    ></sale-confirm-dialog>

    <order-list-dialog
      :dialog.sync="showOrderListDialog"
      :customerName="wholeSaleHeader.customerName"
      :shopId="user.roleName == 'SALE_MANAGER' ? user.shopId : ''"
      @apply="onApplyOrder"
    ></order-list-dialog>

    <customer-list-dialog
      :dialog.sync="showCustomerListDialog"
      :queryParams="customerQueryParams"
      @apply="onApplyCustomer"
    ></customer-list-dialog>

    <whole-sale-detail-item-dialog
      :showDialog="showWholesaleDetailItemDialog"
      :wholesaleItems="wholeSaleHeader.wholeSaleDetails"
      :wsDetail="selectedDetailItem"
      @close="showWholesaleDetailItemDialog = false"
    ></whole-sale-detail-item-dialog>
  </v-container>
</template>
<script>
// import invoice from "./invoice";
import { productService } from "../../services/product-service";
import { taxService } from "../../services/tax-service";
import { Tax } from "../../models/model";
import { WholeSaleHeader } from "../../models/model";
import { wholeSaleService } from "../../services/whole-sale-service";
import { WholeSaleFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
// import { stockService } from "../../services/stock-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import SvgIcon from "@jamescoyle/vue-icon";
import { mdiSaleOutline } from "@mdi/js";

import ParkedSalesDialog from "./ParkedSalesDialog.vue";
import ParkSaleDialog from "./ParkSaleDialog.vue";
import SaleConfirmDialog from "./SaleConfirmDialog.vue";
import OrderListDialog from "./OrderListDialog.vue";
import CustomerListDialog from "./CustomerListDialog.vue";
import CategoryProductList from "./CategoryProductList.vue";
import WholeSaleDetailItemDialog from "./WholeSaleDetailItemDialog.vue";

export default {
  name: "StockList",
  components: {
    Loading,
    SvgIcon,
    ParkedSalesDialog,
    ParkSaleDialog,
    SaleConfirmDialog,
    OrderListDialog,
    CustomerListDialog,
    CategoryProductList,
    WholeSaleDetailItemDialog,
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    rules: new WholeSaleFormRules(),
    valid: true,
    responseError: "",
    pageTitle: "Sale",
    showParkSales: false,
    showNote: false,
    showPaymentMethodDialog: false,
    modalValid: true,
    scanBarcode: "",
    queryParams: {
      categoryId: "",
      barcode: "",
      warehouseId: "",
      status: "",
      binIds: "",
      pricemodelId: "",
    },
    productQueryParams: {
      pricemodelId: "",
    },
    customerQueryParams: {
      regionId: "",
      isNoRegion: Boolean,
      status: "",
      saleTeamId: "",
    },
    autoCompleteParams: {
      code: "",
    },
    decimalFormat: "",
    discountPercentage: 0,
    tax: new Tax(),
    wholeSaleHeader: new WholeSaleHeader(),
    netAmount: 0,
    isShowCurrency: true,
    depositAmount: 0,
    currency: "MMK",

    confirmBox: false,
    productId: "",
    productCode: "",
    productName: "",
    productUnitList: [],
    openProductUnitDialog: false,
    // qcNo: "",
    // batchNo: "",
    // expDate: "",
    // qcNoList: [],
    // batchNoList: [],
    // stockList: [],
    // mfgDateInMilliSeconds: "",
    // expDateInMilliSeconds: "",
    // batchAndQcListLoading: false,
    availableQtyLoading: false,
    isTaxOn: false,
    messageDialogBox: false,
    receivedAmount: 0,
    remainingAmount: 0,
    enteredProductCode: "",
    isFOC: false,
    isItemDiscount: false,
    isAdvancedAmount: false,
    totaladvancedAmount: 0,
    isLoading: false,
    fullPage: true,
    showCustomerListDialog: false,
    showOrderListDialog: false,
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "QUOTATION", value: "QUOTATION" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    issueDate: "",
    oldWholeSaleHeader: new WholeSaleHeader(),
    status: "DRAFT",
    roleName: "",
    marginList: [],
    orderSale: false,
    isDiscountPercentage: true,
    isPromotionPercentage: true,
    productListByCodeOrName: [],
    codeSearch: "",
    isWholesale: true,
    icons: {
      mdiSaleOutline,
    },
    showCategoryProduct: true,
    binList: [],
    orderDate: "",
    selectedDetailItem: {},
    showWholesaleDetailItemDialog: false,
  }),
  computed: {
    wholeSaleDetailList() {
      return this.wholeSaleHeader.wholeSaleDetails.reduce((acc, wsDetail) => {
        const key = `${wsDetail.productId}-${wsDetail.productUnitId}-${wsDetail.isFOC}`;
        if (!acc[key]) {
          acc[key] = { ...wsDetail };
        } else {
          acc[key].qty += wsDetail.qty;
        }
        return acc;
      }, {});
    },
    getFOCItems() {
      return this.wholeSaleHeader.wholeSaleDetails.filter(
        (item) => item.isFOC === true
      );
    },
    getSaleItems() {
      return this.wholeSaleHeader.wholeSaleDetails.filter(
        (item) => item.isFOC !== true
      );
    },
    computedIssueDate() {
      return "Issue: " + this.issueDate;
    },
    computedCustomerOrder() {
      return this.wholeSaleHeader.orderNo
        ? `Order: ${this.wholeSaleHeader.ordNo}`
        : "Import Order";
    },
  },
  watch: {
    wholeSaleHeader: {
      handler() {
        this.calculateAmount();
      },
      deep: true,
    },
    isItemDiscount: {
      handler() {
        this.toggleDiscount();
      },
      deep: true,
    },
    codeSearch: {
      handler() {
        this.getProductListByCodeOrName();
      },
    },
    "$vuetify.breakpoint.smAndDown"(v) {
      if (v) {
        this.showCategoryProduct = false;
      } else {
        this.showCategoryProduct = true;
      }
    },
  },
  created() {
    this.init();
    this.decimalFormat = commonService.formatdecimal();

    if (this.user.saleTeamId) {
      this.customerQueryParams.saleTeamId = this.user.saleTeamId;
    } else {
      // if shop has region, show region customer.
      if (this.user.shop.regionId) {
        this.customerQueryParams.regionId = this.user.shop.regionId;
        this.customerQueryParams.isNoRegion = false;
      } // else show no region customer.
      else {
        this.customerQueryParams.isNoRegion = true;
      }
    }
    this.customerQueryParams.status = "ACTIVE";
  },
  mounted() {
    // setTimeout is needed for page reload case.
    setTimeout(() => {
      this.$emit("drawer", false);
    }, 50);
  },
  destroyed() {
    this.$emit("drawer", null);
  },
  methods: {
    orderedMargins: function (arr) {
      // Set slice() to avoid to generate an infinite loop!
      return arr.slice().sort(function (a, b) {
        return a.level - b.level;
      });
    },
    getProductByCode(enteredProductCode) {
      let isPurchase = false;
      let isSale = true;
      productService
        .getProductByCodeAndPriceModel(
          enteredProductCode,
          this.wholeSaleHeader.priceModelId,
          this.wholeSaleHeader.binId,
          isPurchase,
          isSale
        )
        .then((res) => {
          if (res.data) {
            this.showProductUnitDialog(res.data);
          } else {
            this.responseError = "Invalid Product Code !";
            this.messageDialogBox = true;
          }
          this.enteredProductCode = "";
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getProductListByCodeOrName() {
      if (
        this.codeSearch &&
        this.codeSearch.length > 50 &&
        this.productListByCodeOrName.length > 0
      ) {
        return;
      }
      let searchParams = {
        code: this.codeSearch,
        name: this.codeSearch,
      };
      if (this.codeSearch) {
        productService
          .getProductByNameOrCode(searchParams)
          .then((res) => {
            this.productListByCodeOrName = res.data;
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
          });
      }
    },

    productSelectFilter(item, queryText, itemText) {
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      );
    },

    confirmPayment() {
      if (!this.$refs.paymentModalForm.validate()) {
        return;
      }
      this.showPaymentMethodDialog = false;
      this.confirmBox = true;
    },
    proceedPayment() {
      if (!this.isLoading) {
        this.isLoading = true;
        this.save();
        this.showPaymentMethodDialog = false;
        this.confirmBox = false;
      }
    },
    cancelPayment() {
      this.showPaymentMethods();
    },
    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    showCustomers() {
      // Clean query params
      this.showCustomerListDialog = true;
    },
    showOrders() {
      this.showOrderListDialog = true;
    },
    getTax() {
      return taxService
        .getTaxByStatus("ACTIVE")
        .then((res) => {
          if (res.data) {
            this.tax = res.data;
            this.wholeSaleHeader.taxId = this.tax.id;
            this.wholeSaleHeader.taxName = this.tax.name;
            this.wholeSaleHeader.taxType = this.tax.taxType;
            this.wholeSaleHeader.taxPercentage = this.tax.percentage;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    addToCart(productUnit) {
      if (this.isItemExist(productUnit, this.isFOC)) {
        let isFOCFlag = this.isFOC;
        this.wholeSaleHeader.wholeSaleDetails.forEach(function (item) {
          if (
            item.productUnitId === productUnit.id &&
            item.isFOC === isFOCFlag
          ) {
            item.qty = Math.abs(item.qty) + 1;
          }
        });
      } else {
        let item = {
          productUnitId: 0,
          productCode: "",
          productId: 0,
          qty: 0,
          unitPrice: 0,
          barcode: "",
          totalPrice: 0,
          factorUnitName: "",
          productName: "",
          isFOC: false,
          discountPercent: false,
          minPrice: 0,
          remark: "",
          sellingPrice: 0,
          wholeSaleSellingPrice: 0,
          // qcNo: "",
          // batchNo: "",
          // mfgDateInMilliSeconds: "",
          // expDateInMilliSeconds: "",
        };

        item.productUnitId = productUnit.id;
        item.productId = productUnit.product.id;
        item.productCode = productUnit.product.code;
        item.barcode = productUnit.barcode;
        item.qty = 1;
        item.unitPrice = this.getSellingPrice(productUnit);
        item.factorUnitName = productUnit.factorUnitName;
        item.productName = productUnit.product.name;
        item.discountPercent = productUnit.wholeSaleSellingPricePercentage;
        item.minPrice = productUnit.unitCost;
        item.sellingPrice = productUnit.sellingPrice;
        item.wholeSaleSellingPrice = productUnit.wholeSaleSellingPrice;
        // item.qcNo = this.qcNo;
        // item.batchNo = this.batchNo;
        // item.mfgDateInMilliSeconds = this.mfgDateInMilliSeconds;
        // item.expDateInMilliSeconds = this.expDateInMilliSeconds;
        if (this.isFOC) {
          item.isFOC = this.isFOC;
        }
        this.wholeSaleHeader.wholeSaleDetails.push(item);
      }
    },
    closeProductUnitDialog() {
      this.openProductUnitDialog = false;
      // this.qcNo = "";
      // this.batchNo = "";
      // this.expDate = "";
      // this.qcNoList = [];
      // this.batchNoList = [];
      // this.stockList = [];
      // this.expDateInMilliSeconds = "";
      // this.mfgDateInMilliSeconds = "";
    },
    toggleDiscount() {
      if (this.isItemDiscount) {
        this.wholeSaleHeader.isItemDiscount = true;
      } else {
        this.wholeSaleHeader.isItemDiscount = false;
      }
    },
    calculateAmount() {
      let total = 0;
      this.wholeSaleHeader.wholeSaleDetails.forEach((item) => {
        if (!item.isFOC) {
          if (this.isItemDiscount) {
            let discount = (
              item.unitPrice *
              (item.discountPercent / 100)
            ).toFixed(6);
            discount = parseFloat(discount);
            item.totalPrice = item.qty * (item.unitPrice - discount);
            total += item.totalPrice;
          } else {
            item.totalPrice = item.qty * item.unitPrice;
            total += item.totalPrice;
          }
        }
      });
      total = parseFloat(total.toFixed(6));
      // Calculate margin amount
      this.marginList = [];
      let totalMarginAmount = 0;
      if (this.wholeSaleHeader.wholeSaleMarginList) {
        let wholeSaleMarginList = this.wholeSaleHeader.wholeSaleMarginList;
        wholeSaleMarginList.forEach((obj) => {
          let amount = (total * obj.percentage) / 100;

          let margin = {
            level: "",
            name: "",
            percentage: "",
            amount: 0,
          };
          obj.amount = amount;

          margin.level = obj.level;
          margin.name = obj.name;
          margin.percentage = obj.percentage;
          margin.amount = amount;
          this.marginList.push(margin);

          totalMarginAmount += amount;
        });
      }

      this.wholeSaleHeader.totalAmount = total;
      let commercialTax = 0;
      if (this.wholeSaleHeader.taxPercentage > 0) {
        commercialTax = parseFloat(
          (total * (this.wholeSaleHeader.taxPercentage / 100)).toFixed(6)
        );
      }
      if (!this.isTaxOn) {
        commercialTax = 0;
      }
      let taxType = this.wholeSaleHeader.taxType;
      if (taxType === "ADD_ON") {
        this.netAmount = total + commercialTax;
      } else {
        this.netAmount = total - commercialTax;
      }
      this.wholeSaleHeader.taxAmount = commercialTax;
      if (this.isDiscountPercentage) {
        this.wholeSaleHeader.discountAmount = parseFloat(
          (
            this.netAmount *
            (this.wholeSaleHeader.discountPercentage / 100)
          ).toFixed(6)
        );
      }
      this.netAmount = parseFloat(
        this.netAmount +
          parseFloat(this.wholeSaleHeader.deliveryFee) -
          this.wholeSaleHeader.discountAmount -
          totalMarginAmount
      ).toFixed(6);

      if (this.isPromotionPercentage) {
        this.wholeSaleHeader.promotionAmount = parseFloat(
          (
            this.netAmount *
            (this.wholeSaleHeader.promotionPercentage / 100)
          ).toFixed(6)
        );
      }
      this.netAmount = parseFloat(
        (this.netAmount - this.wholeSaleHeader.promotionAmount).toFixed(6)
      );

      this.receivedAmount = this.netAmount;
      this.remainingAmount = parseFloat(
        this.netAmount - this.depositAmount
      ).toFixed(6);
    },
    onAdvancedAmount() {
      if (this.isAdvancedAmount) {
        if (this.totaladvancedAmount < this.netAmount) {
          this.depositAmount = this.totaladvancedAmount;
        } else if (this.totaladvancedAmount >= this.netAmount) {
          this.depositAmount = this.netAmount;
        }
      } else {
        this.depositAmount = 0;
      }
    },
    changeDepositAmount() {
      if (this.isAdvancedAmount) {
        if (this.depositAmount > this.totaladvancedAmount) {
          this.$nextTick(() => {
            this.depositAmount = this.totaladvancedAmount;
          });
          console.log(this.depositAmount);
          this.responseError =
            "Deposit Amount must not be greater than Total Advanced Amount";
          this.messageDialogBox = true;
        }
      }
    },
    save() {
      //convert to millisecond
      this.wholeSaleHeader.issueDateInMilliSeconds =
        commonService.convertToMilliseconds(this.issueDate);
      this.wholeSaleHeader.isAdvancedAmount = this.isAdvancedAmount;
      this.wholeSaleHeader.netAmount = this.netAmount;
      this.wholeSaleHeader.receivedAmount = this.receivedAmount;
      this.wholeSaleHeader.depositAmount = this.depositAmount;
      this.wholeSaleHeader.taxPercentage = this.isTaxOn
        ? this.wholeSaleHeader.taxPercentage
        : 0;
      this.wholeSaleHeader.isWholesale =
        this.isWholesale == true ? true : false;

      if (this.orderDate) {
        this.wholeSaleHeader.orderDateInMilliSeconds =
          commonService.convertToMilliseconds(this.orderDate);
      }
      wholeSaleService
        .save(this.wholeSaleHeader)
        .then((res) => {
          if (res.data.wholeSaleHeader) {
            this.wholeSaleHeader.issueNo = res.data.wholeSaleHeader.issueNo;
            this.wholeSaleHeader.saleId = res.data.wholeSaleHeader.id;
          }
        })
        .then(() => {
          if (this.wholeSaleHeader.id) {
            this.goBack();
          } else {
            this.printInvoiceById(this.wholeSaleHeader.saleId);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
            this.messageDialogBox = true;
            this.isLoading = false;
          }
        })
        .finally(() => {
          this.isItemDiscount = false;
          this.depositAmount = 0;
        });
    },
    printInvoiceById(id) {
      wholeSaleService
        .printInvoiceById(id)
        .then((res) => {
          var blob = res;
          wholeSaleService.showWindowDialog(blob, "WholeSaleInvoice-" + id);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.init();
        });
    },
    printInvoice(divName) {
      var d = new Date();
      var t = d.toLocaleTimeString();
      var mydate = new Date().toString("MMMM yyyy");
      document.getElementById("date").innerHTML = mydate.substr(0, 16) + t;
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();

      // clear previous cart item
      this.init();
    },
    printOrderNote(divName) {
      var d = new Date();
      var t = d.toLocaleTimeString();
      var mydate = new Date().toString("MMMM yyyy");
      document.getElementById("orderNoteDate").innerHTML =
        mydate.substr(0, 16) + t;
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = "";
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
    init() {
      const id = this.$route.params.id;
      this.isLoading = false;
      if (id == "new") {
        // new stockin
        this.status = "NEW";
        this.issueDate = commonService.formatDate(
          new Date().toISOString().substring(0, 10),
          "YYYY-MM-DD"
        );
      } else {
        this.getWholeSaleDetail(id);
      }
      if (this.wholeSaleHeader) {
        this.wholeSaleHeader = new WholeSaleHeader();
      }
      //this.getTax();

      let user = JSON.parse(localStorage.getItem("user"));
      this.roleName = user.roleName;
      if (
        this.roleName == "SALE_MANAGER" ||
        this.roleName == "GENERAL_MANAGER"
      ) {
        this.wholeSaleHeader.shopId = user.shop.id;
        this.wholeSaleHeader.shopName = user.shop.name;
        this.wholeSaleHeader.phoneNo = user.shop.phoneNo;
        this.wholeSaleHeader.address = user.shop.address;
      }
      if (this.roleName == "SALE_MANAGER" || this.roleName == "SALE") {
        this.wholeSaleHeader.saleTeamId = user.saleTeamId;
      }
      this.wholeSaleHeader.username = user.username;

      this.orderSale = false;

      // check mobiles
      if (this.$vuetify.breakpoint.smAndDown) {
        this.showCategoryProduct = false;
      } else {
        this.showCategoryProduct = true;
      }

      // check park items
      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      if (parkItemsLocalStorage) {
        this.parkItems = parkItemsLocalStorage;
      }

      this.getBinList(this.wholeSaleHeader.shopId);

      //for deep linking
      if (this.$route.query.status) {
        this.queryParams.status = this.$route.query.status;
      }
      if (this.$route.query.categoryId) {
        this.queryParams.categoryId = this.$route.query.categoryId;
      }
      if (this.$route.query.barcode) {
        this.queryParams.barcode = this.$route.query.barcode;
      }
      if (this.$route.query.page) {
        this.pagination.page = this.$route.query.page;
      }
      if (this.$route.query.size) {
        this.pagination.size = this.$route.query.size;
      }
      if (this.$route.query.categoryId) {
        this.queryParams.categoryId = this.$route.query.categoryId;
      }
      if (this.$route.query.warehouseId) {
        this.queryParams.warehouseId = this.$route.query.warehouseId;
      } else {
        this.queryParams.warehouseId = user.shop.warehouse.id;
      }
      this.queryParams.pricemodelId = "";
    },

    showProductUnitDialog(product) {
      this.openProductUnitDialog = true;
      this.productUnitList = product.productUnits;
      this.productId = product.id;
      this.productCode = product.code;
      this.productName = product.name;
      // this.getBatchNoListAndQcNoList();
    },
    // getBatchNoListAndQcNoList() {
    //   this.batchAndQcListLoading = true;
    //   let params = {
    //     productId: this.productId,
    //     binId: this.wholeSaleHeader.binId,
    //   };
    //   stockService
    //     .getBatchListAndQcList(params)
    //     .then((res) => {
    //       if (res.data) {
    //         let tempBatchNoList = res.data.batchNoList;
    //         let tempQcList = res.data.qcNoList;
    //         this.batchNoList = tempBatchNoList.map((i) => {
    //           if (i != null) return { label: i, value: i };
    //           else return { label: "", value: "" };
    //         });
    //         this.qcNoList = tempQcList.map((i) => {
    //           if (i != null) return { label: i, value: i };
    //           else return { label: "", value: "" };
    //         });
    //         this.stockList = res.data.stockList;
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       this.batchAndQcListLoading = false;
    //     });
    // },
    getAvailableStockQty() {
      this.availableQtyLoading = true;
      let isPurchase = false;
      let isSale = true;
      productService
        .getProductByCodeAndPriceModel(
          this.productCode,
          this.wholeSaleHeader.priceModelId,
          this.wholeSaleHeader.binId,
          isPurchase,
          isSale,
          this.qcNo,
          this.batchNo
        )
        .then((res) => {
          if (res.data) {
            let product = res.data;
            this.productUnitList = product.productUnits;
            this.productId = product.id;
            this.productCode = product.code;
            this.productName = product.name;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.availableQtyLoading = false;
        });
    },
    // changeExpDate() {
    //   let stock = this.stockList.find(
    //     (i) => i.batchNo == this.batchNo && i.qcNo == this.qcNo
    //   );
    //   if (stock) {
    //     this.mfgDateInMilliSeconds = stock.mfgDateInMilliSeconds;
    //     this.expDateInMilliSeconds = stock.expDateInMilliSeconds;
    //     if (stock.expDateInMilliSeconds) {
    //       this.expDate = commonService.millisecondToDate(
    //         stock.expDateInMilliSeconds,
    //         "YYYY-MM-DD"
    //       );
    //     } else this.expDate = "";
    //   } else {
    //     this.expDate = "";
    //     this.mfgDateInMilliSeconds = "";
    //     this.expDateInMilliSeconds = "";
    //   }
    // },

    removeItem(wsDetail) {
      let deleteItemList = this.wholeSaleHeader.wholeSaleDetails.filter(
        (e) =>
          e.productId == wsDetail.productId &&
          e.productUnitId == wsDetail.productUnitId &&
          e.isFOC == wsDetail.isFOC
      );

      for (const item of deleteItemList) {
        const index = this.wholeSaleHeader.wholeSaleDetails
          .map((d) => `${d.productId}-${d.productUnitId}-${d.isFOC}`)
          .indexOf(`${item.productId}-${item.productUnitId}-${item.isFOC}`);

        if (item.id) {
          // add delete stock in id
          if (!this.wholeSaleHeader.deleteWholeSaleDetailIds) {
            this.wholeSaleHeader.deleteWholeSaleDetailIds = [];
          }
          this.wholeSaleHeader.deleteWholeSaleDetailIds.push(item.id);
        }
        this.$delete(this.wholeSaleHeader.wholeSaleDetails, index);
      }
    },
    // removeItem(index, wholeSaleHeaderId) {
    //   if (wholeSaleHeaderId) {
    //     // add delete stock in id
    //     if (!this.wholeSaleHeader.deleteWholeSaleDetailIds) {
    //       this.wholeSaleHeader.deleteWholeSaleDetailIds = [];
    //     }
    //     this.wholeSaleHeader.deleteWholeSaleDetailIds.push(wholeSaleHeaderId);
    //   }
    //   this.$delete(this.wholeSaleHeader.wholeSaleDetails, index);
    // },
    onParked() {
      this.init();
    },
    onRetrievedParked(item) {
      this.wholeSaleHeader = item;

      if (item.orderId && item.orderNo) {
        this.orderSale = true;
      }
    },
    closeModal() {
      this.$refs.noteDialog.resetValidation();
      this.showNote = false;
    },
    showPaymentMethods() {
      if (this.$refs.form.validate()) {
        this.showPaymentMethodDialog = true;
        this.confirmBox = false;
      }
      /*if (this.wholeSaleHeader.orderNo){
        this.wholeSaleHeader.orderNoText = this.wholeSaleHeader.ordNo ;
        this.orderDate = this.wholeSaleHeader.orderDate;
      }*/
    },
    isItemExist(productUnit, isFOC) {
      for (let item of this.wholeSaleHeader.wholeSaleDetails) {
        if (
          item.productUnitId === productUnit.id &&
          // item.batchNo == this.batchNo &&
          // item.qcNo == this.qcNo &&
          item.isFOC === isFOC
        ) {
          return true;
        }
      }
    },

    getProductUnitByBarcode(bcode) {
      let params = {
        barcode: bcode,
        priceModelId: this.wholeSaleHeader.priceModelId,
        binId: this.wholeSaleHeader.binId,
        isSale: true,
      };
      productService
        .getProductUnitByBarcode(params)
        .then((res) => {
          let productUnit = res.data;
          if (productUnit) {
            if (productUnit.qty > 0) {
              this.addToCart(productUnit);
            }
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
            this.messageDialogBox = true;
          }
        })
        .finally(() => {
          this.scanBarcode = "";
        });
    },
    onApplyCustomer(customer) {
      this.wholeSaleHeader.customerId = customer.id;
      this.wholeSaleHeader.customerName = customer.name;
      this.wholeSaleHeader.customerAddress = customer.address;
      this.wholeSaleHeader.deliveryInfo = customer.address;
      this.totaladvancedAmount = customer.advancedAmount;
      this.wholeSaleHeader.wholeSaleMarginList = this.orderedMargins(
        customer.marginList
      );
      this.showCustomerListDialog = false;
      this.onAdvancedAmount();
      if (customer.priceModelId) {
        this.productQueryParams.pricemodelId = customer.priceModelId;
        this.wholeSaleHeader.priceModelId = customer.priceModelId;
      }
      // this.getProductList();
    },
    onApplyOrder(order) {
      this.wholeSaleHeader.orderId = order.id;
      this.wholeSaleHeader.ordNo = order.orderNo;
      /*this.wholeSaleHeader.orderDate = commonService.formatDate(
          new Date(order.orderDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );*/
      this.wholeSaleHeader.orderNo = order.issueNo;
      this.showOrderListDialog = !this.showOrderListDialog;
      this.orderSale = true;
      // this.wholeSaleHeader.wholeSaleDetails = [];
      if (order.promotionPercent > 0) {
        this.isPromotionPercentage = true;
      } else {
        this.isPromotionPercentage = false;
      }
      this.wholeSaleHeader.promotionPercentage = order.promotionPercent;
      this.wholeSaleHeader.promotionAmount = order.promotionAmount;
      if (order.discountPercent > 0) {
        this.isDiscountPercentage = true;
      }else {
        this.isDiscountPercentage = false;
      }
      this.wholeSaleHeader.discountPercentage = order.discountPercent;
      this.wholeSaleHeader.discountAmount = order.discountAmount;
      this.wholeSaleHeader.deliveryFee = order.deliveryFee;
      this.wholeSaleHeader.deliveryInfo = order.deliveryAddress;
      this.wholeSaleHeader.description = order.remark;

      // for (let orderItem of order.orderHeadDetails) {
      //   let item = {
      //     productUnitId: 0,
      //     productId: 0,
      //     qty: 0,
      //     unitPrice: 0,
      //     barcode: "",
      //     totalPrice: 0,
      //     factorUnitName: "",
      //     productName: "",
      //     isFOC: false,
      //     discountPercent: false,
      //     minPrice: 0,
      //     remark: "",
      //     sellingPrice: 0,
      //     wholeSaleSellingPrice: 0,
      //   };

      //   item.productUnitId = orderItem.productUnitId;
      //   item.productId = orderItem.productId;
      //   item.barcode = orderItem.productUnitDTO.barcode;
      //   item.qty = orderItem.confirmQty;
      //   item.unitPrice = this.getSellingPrice(orderItem.productUnitDTO);
      //   item.factorUnitName = orderItem.factorUnitName;
      //   item.productName = orderItem.productName;
      //   item.discountPercent =
      //     orderItem.productUnitDTO.wholeSaleSellingPricePercentage;
      //   item.minPrice = orderItem.productUnitDTO.unitCost;
      //   item.sellingPrice = orderItem.productUnitDTO.sellingPrice;
      //   item.wholeSaleSellingPrice =
      //     orderItem.productUnitDTO.wholeSaleSellingPrice;

      //   this.wholeSaleHeader.wholeSaleDetails.push(item);
      // }
    },
    getWholeSaleDetail(id) {
      wholeSaleService.getWholeSaleDetail(id).then((res) => {
        this.isItemDiscount = res.data.isItemDiscount;
        this.isAdvancedAmount = res.data.isAdvancedAmount;
        this.totaladvancedAmount = res.data.customer.advancedAmount;
        this.depositAmount = res.data.depositAmount;
        this.wholeSaleHeader = res.data;
        if (this.wholeSaleHeader.orderNo) this.orderSale = true;
        this.productQueryParams.pricemodelId =
          this.wholeSaleHeader.priceModelId;
        if (this.wholeSaleHeader) {
          if (this.wholeSaleHeader.taxAmount > 0) {
            this.isTaxOn = true;
          }
          this.isWholesale =
            this.wholeSaleHeader.isWholesale == true ? true : false;

          if (this.wholeSaleHeader.discountPercentage > 0) {
            this.isDiscountPercentage = true;
          } else if (this.wholeSaleHeader.discountPercentage == 0) {
            this.isDiscountPercentage = false;
          }

          if (this.wholeSaleHeader.promotionPercentage > 0) {
            this.isPromotionPercentage = true;
          } else if (this.wholeSaleHeader.promotionPercentage == 0) {
            this.isPromotionPercentage = false;
          }

          if (this.wholeSaleHeader.wholeSaleMarginList.length > 0) {
            let wholeSaleMarginList = this.wholeSaleHeader.wholeSaleMarginList;
            wholeSaleMarginList.forEach((obj) => {
              let margin = {
                level: "",
                name: "",
                percentage: "",
                amount: 0,
              };
              margin.level = obj.level;
              margin.name = obj.name;
              margin.percentage = obj.percentage;
              margin.amount = obj.amount;
              this.marginList.push(margin);
            });
          }
        }
        this.issueDate = commonService.millisecondToDate(
          this.wholeSaleHeader.issueDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        if (this.wholeSaleHeader.orderDateInMilliSeconds) {
          this.orderDate = commonService.millisecondToDate(
            this.wholeSaleHeader.orderDateInMilliSeconds,
            "YYYY-MM-DD"
          );
        }
        this.status = this.wholeSaleHeader.status;
        // deep copy
        this.oldWholeSaleHeader = JSON.parse(JSON.stringify(res.data));
        // this.getProductList();
      });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.wholeSaleHeader.id) {
        this.wholeSaleHeader = new WholeSaleHeader();
      } else {
        this.wholeSaleHeader = Object.assign({}, this.oldWholeSaleHeader);
      }
    },
    goBack() {
      this.$router.back();
    },
    changeDiscountSwitch() {
      this.wholeSaleHeader.discountPercentage = 0;
      this.wholeSaleHeader.discountAmount = 0;
      this.calculateAmount();
    },
    changePromotionSwitch() {
      this.wholeSaleHeader.promotionPercentage = 0;
      this.wholeSaleHeader.promotionAmount = 0;
      this.calculateAmount();
    },
    changeTaxOn() {
      this.getTax().then(() => {
        this.calculateAmount();
      });
    },
    onSaleConfirm() {
      this.proceedPayment();
    },
    getSellingPrice(item) {
      let price = 0;
      if (this.isWholesale == true) {
        price = item.wholeSaleSellingPrice;
      } else {
        price = item.sellingPrice;
      }
      return price;
    },

    changeSellingPrice() {
      this.wholeSaleHeader.wholeSaleDetails.forEach((item) => {
        item.unitPrice = this.getSellingPrice(item);
      });
    },

    getBinList(shopId) {
      shopService
        .getShopBinList(shopId)
        .then((res) => {
          this.binList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    onShowDetail(wsDetail) {
      this.selectedDetailItem = wsDetail;
      this.showWholesaleDetailItemDialog = true;
    },

    onChangeDetail(wsDetail) {
      this.wholeSaleHeader.wholeSaleDetails.map((e) => {
        if (
          e.productCode == wsDetail.productCode &&
          e.factorUnitName == wsDetail.factorUnitName &&
          e.isFOC == wsDetail.isFOC
        ) {
          e.unitPrice = wsDetail.unitPrice;
          e.qty = wsDetail.qty;
          e.discountPercent = wsDetail.discountPercent;
          e.remark = wsDetail.remark;
        }
      });
    },
  },
};
</script>

<style scoped>
.cart {
  font-size: 12px;
}
.small-font {
  font-size: 14px;
}
.top-sticky {
  position: sticky;
  top: 88px;
  z-index: 1;
}
.bottom-sticky {
  position: sticky;
  bottom: 24px;
  z-index: 1;
}
.cart-list-container {
  height: calc(
    100vh - 380.5px
  ); /* Subtract the height of the toolbar, topbtn, paddings, and summary sections */
  overflow-y: auto;
}
.cart-item {
  border-left: 5px solid blue;
}
.cart-item-foc {
  border-left: 5px solid green;
}
</style>
